import React from "react";
import "./CustomerTransactions.css";

const CustomerTransactions = () => {
  return (
    <div className="transaction-container">
      <h3>Transactions</h3>
      <table className="transaction-table">
        <thead>
          <tr>
            <th>Transaction ID</th>
            <th>Date</th>
            <th>Amount</th>
            <th>Transaction Type</th>
            <th>Payment Method</th>
            <th>Customer Name</th>
            <th>Status</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>T0001</td>
            <td>2024-12-13</td>
            <td>100.00 AED</td>
            <td>Payment</td>
            <td>Credit Card</td>
            <td>John Doe</td>
            <td>Completed</td>
            <td>Payment for services</td>
          </tr>
        </tbody>
      </table>
      <button className="transaction-back-button">Back</button>
    </div>
  );
};

export default CustomerTransactions;
